import styled, { css, breakpoints } from '../../styles/theme';
import StockCardTemplate from './StockCardTemplate';
import { rem } from 'polished';

export const StockCardWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const DeliveryDate = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: ${rem('35px')};

    svg {
        width: ${rem('15px')};
        height: ${rem('15px')};
    }

    span {
        margin-left: 10px;
        font-size: ${({ theme }) => theme.fontSizes.h6};
        color: ${({ theme }) => theme.colors.grey12};
    }
`;

export const PriceBoxContainer = styled.div<{ isStockJourney: boolean }>`
    width: 100%;
    max-width: ${rem('349px')};
    margin-left: auto;
    margin-right: auto;

    @media (max-width: ${breakpoints.sm}px) {
        padding: ${rem('10px')} ${rem('20px')};
        max-width: unset;
        margin-left: unset;
        margin-right: unset;
    }
`;

export const StockCardStyled = styled(StockCardTemplate)`
    display: grid;
    grid-template-rows: auto 1fr 3rem auto auto 1fr;
    max-width: ${rem('392px')};
    width: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.primaryDisabled};

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.6;
            pointer-events: none;
        `}

    .stockModelCard-discounts {
        padding: ${rem('10px')} ${rem('15px')};
        color: ${({ theme }) => theme.colors.white};
        background-color: ${({ theme }) => theme.colors.default};
        text-align: left;
        border-top: 2px solid ${({ theme }) => theme.colors.blue8};
    }
`;
